import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';
import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import { hideNumber } from '../../helpers/titreHelper';

const Message = ({ className, message, setDelay, messagesWrapper, user }) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper
  );

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      {message?.content && (
        <>
          <div className={styles.nameBlock}>
            <div className={styles.avatar}>
              <img
                src={
                  (message?.image !== '1' && message?.image) ||
                  iconsSources[message?.channel]
                }
                alt={message?.author}
                onError={errorHandler}
              />
            </div>
            <div className={styles.name}>
              <div>{message?.senderNumber}</div>
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.textWrapper} ref={contentContainerRef}>
              <div className={styles.text} ref={contentRef}>
                {message?.content}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
